module.exports = __webpack_public_path__ + "static/media/thorunknown.bb936147.svg";